import clsx from 'clsx';
import { useMemo } from 'react';
import useTraitSwapStore from '../hooks/useTraitSwapStore';
import { getTraitImagePath } from '../utils/traits';

const TraitSwapPreviewLayer = ({ layer }) => {
  const { selectedNfts, swapLayer, swappedLayers } = useTraitSwapStore();
  const firstKitty = selectedNfts[0];
  const secondKitty = selectedNfts[1];

  const firstKittyLayerValue = firstKitty.metadata?.properties?.[layer];
  const firstKittyImageUrl = useMemo(
    () => getTraitImagePath(layer, firstKittyLayerValue, firstKitty.metadata?.properties),
    [layer, firstKittyLayerValue]
  );

  const secondKittyLayerValue = secondKitty.metadata?.properties?.[layer];
  const secondKittyImageUrl = useMemo(
    () => getTraitImagePath(layer, secondKittyLayerValue, secondKitty.metadata?.properties),
    [layer, secondKittyLayerValue]
  );

  const isSwapped = swappedLayers.includes(layer);

  const onClick = () => {
    swapLayer(layer);
  };

  return (
    <div className='flex w-full gap-2 md:gap-6'>
      <div className='flex w-1/2 flex-col gap-2 h-full'>
        <div
          className={clsx(
            'flex flex-col md:flex-row md:h-[92px] items-center gap-4 text-center md:text-left md:gap-8 rounded-lg bg-gray-900 p-2 md:p-4',
            isSwapped && 'bg-gray-700'
          )}
        >
          <div className='aspect-square max-w-[60px] overflow-hidden rounded-lg bg-gray-800 shrink-0'>
            <img src={isSwapped ? secondKittyImageUrl : firstKittyImageUrl} alt={layer} width={300} height={300} />
          </div>
          <div>
            <p className={clsx('text-xs md:text-sm text-gray-300')}>
              {isSwapped ? '2nd Kitty' : '1st Kitty'} {layer}
            </p>
            <p className={clsx('text-sm md:text-xl text-gray-100')}>{isSwapped ? secondKittyLayerValue : firstKittyLayerValue}</p>
          </div>
        </div>
      </div>

      <div className='flex items-end justify-center w-[45px] md:w-[60px]'>
        <button onClick={onClick} className={clsx('group flex-col items-center justify-center flex')}>
          <div
            className={clsx(
              'w-10 h-10 flex items-center justify-center transition-colors duration-300 rounded-full bg-gray-900',
              isSwapped && 'bg-primary-500 text-black'
            )}
          >
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512' className={clsx('w-4 h-4 text-gray-400 text-lg text-current')}>
              <path
                d='M103 497c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55L424 408c13.3 0 24-10.7 24-24s-10.7-24-24-24L81.9 360l55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L7 367c-9.4 9.4-9.4 24.6 0 33.9l96 96zM441 145c9.4-9.4 9.4-24.6 0-33.9L345 15c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55L24 104c-13.3 0-24 10.7-24 24s10.7 24 24 24l342.1 0-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l96-96z'
                fill='currentColor'
              />
            </svg>
          </div>
          <span className='text-sm text-gray-400 mt-3 block'>{isSwapped ? 'Undo' : 'Swap'}</span>
        </button>
      </div>

      <div className='flex w-1/2 flex-col gap-2 h-full'>
        <div
          className={clsx(
            'flex flex-col md:flex-row md:h-[92px] items-center gap-4 text-center md:text-left md:gap-8 rounded-lg bg-gray-900 p-2 md:p-4',
            isSwapped && 'bg-gray-700'
          )}
        >
          <div className='aspect-square max-w-[60px] overflow-hidden rounded-lg bg-gray-800 shrink-0'>
            <img src={isSwapped ? firstKittyImageUrl : secondKittyImageUrl} alt={layer} width={300} height={300} />
          </div>
          <div>
            <p className={clsx('text-xs md:text-sm text-gray-300')}>
              {isSwapped ? '1st Kitty' : '2nd Kitty'} {layer}
            </p>
            <p className={clsx('text-sm md:text-xl text-gray-100')}>{isSwapped ? firstKittyLayerValue : secondKittyLayerValue}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TraitSwapPreviewLayer;
